import { MotorStatusMdl } from './../../Models/MotorStatusMdl';
import { ProfileReqMdl, CustomerProfileMdl } from './../../Models/CustomerProfileMdl';
import { motorProposalService } from './../../Services/motorProposalService';
import { restURL } from './../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { OtpVerifyReq } from '../../Models/OtpVerifyReq';
import { OtpVerifyRes } from '../../Models/OtpVerifyRes';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/observable/timer";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/takeUntil";
import "rxjs/add/operator/map";
import { userService } from '../../Services/userService';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../Services/languageService';
import Swal from "sweetalert2";
import * as CryptoJS from 'crypto-js';
import { mdlEmailOtpVerifyReq } from '../../Models/mdlEmailOtpVerifyReq';
import { mdlPayloadRequest } from '../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../Models/mdlPayloadResponse';
import { TranslateService } from '@ngx-translate/core';
import { mdlGetMobilenoVerificationRes } from '../../Models/mdlGetMobilenoVerificationRes';
@Component({
  selector: 'Profile',
  templateUrl: './Profile.html',
  styleUrls: ['./Profile.css']
})
export class Profile {

  public License: boolean;
  public OTP: boolean;
  public Vehicle: boolean;
  public Count: number = 1;
  public Motor: boolean;
  public SelectedType: string;
  public Hasfield: boolean = false;
  public isShowLoading: boolean = false;
  public profileReq: ProfileReqMdl = new ProfileReqMdl();
  public profileObj: CustomerProfileMdl = new CustomerProfileMdl();
  public st: MotorStatusMdl = new MotorStatusMdl();
  public objmdlEmailOtpVerifyReq: mdlEmailOtpVerifyReq = new mdlEmailOtpVerifyReq();
  public EmailAddressmodal: boolean;
  public MobileUpdatemodal: boolean;
  public LangUpdatemodal: boolean;
  public IBANUPDATEmodal: boolean;
  public DisableMobileUpdate: boolean;
  public PasswordUpdatemodal: boolean;
  public AddressUpdatemodal: boolean;
  public PasswordMatched: boolean;
  public otpReq: OtpVerifyReq = new OtpVerifyReq();
  public otpRes: OtpVerifyRes = new OtpVerifyRes();
  public showOTP: boolean;
  public isResendShow: boolean;
  public isShowTimer: boolean;
  public CurrentTime: number;
  public RemainTime: number;
  public showLoading: boolean;
  public IBAN: string;
  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;
  public BankCode: string;
  public subscription: any;
  public ShowVerify: boolean;
  public LngSubscription: Subscription;
  public NatEn: string;
  public NatAr: string;
  public Lng: string;
  public AccountName: string;


  public IsShowOTPBlock: boolean = false;
  public timeLeft: number = 180;
  public interval;
  public ShowEmailTimer: boolean = false;
  public isResendShowEmail: boolean = false;
  public EmailOTP: string
  public MobileNoVerified:boolean=false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  public YakeenMobileres:mdlGetMobilenoVerificationRes=new mdlGetMobilenoVerificationRes();


  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  @ViewChild('MobileUpdatemodal') public modal: ModalDirective;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  constructor(private translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private userinfo: userService, private lngService: LanguageService) {
    this.RemainTime = 300;
    this.showOTP = false;
    this.PasswordMatched = true;
    this.isResendShow = false;
    this.getProfile();
    this.DisableMobileUpdate = true;
    this.ShowVerify = false;

    this.NatEn = sessionStorage.getItem("NatEn");
    this.NatAr = sessionStorage.getItem("NatAr");

    this.LangUpdatemodal = false;
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
  }
  UpdateEmail(val) {
    if (!val) {
      Swal("Please Fill All Mandatory Fields..")
      return;
    }
    this.isShowLoading = true;
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.EditEmailAddress = true;
    this.profileReq.EditIBANNo = false;
    this.profileReq.EditMobileNo = false;
    this.profileReq.EditLang = false;
    this.profileReq.EditPassword = false;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      if (this.st.StatusCode == "S" && this.st.Result == "VERIFY OTP") {
        this.IsShowOTPBlock = true;
        this.showOTPTimerEmail();
        this.ShowEmailTimer = true;
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
      }
      else {
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
        this.getProfile();
        this.EmailAddressmodal = false;
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });

  }
  verifyEmailOTP() {
    this.isShowLoading = false;
    this.objmdlEmailOtpVerifyReq.RegNo = sessionStorage.getItem("RegNo");
    this.objmdlEmailOtpVerifyReq.InsuredEmailId = this.profileReq.EmailID;
    this.objmdlEmailOtpVerifyReq.OTP = this.EmailOTP;
    this.objmdlEmailOtpVerifyReq.Lang = this.Lng;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlEmailOtpVerifyReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/VerifyOTP_ForEmailUpdate", this.objmdlEmailOtpVerifyReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/VerifyOTP_ForEmailUpdate", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      Swal(this.st.StatusDesc);
      if (this.st.StatusCode == "S") {
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.IsShowOTPBlock = false;
        this.ShowEmailTimer = false;
        this.EmailOTP = "";
        this.getProfile();
        this.EmailAddressmodal = false;
      } else {
        if (this.st.Result == "E") {
          this.isResendShowEmail = false;
          clearInterval(this.interval);
          this.timeLeft = 180;
          this.showOTPTimerEmail();
        }

      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }
  showOTPTimerEmail() {
    this.ShowEmailTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.timeLeft = 0;
        this.isResendShowEmail = true;
      } else {
        this.timeLeft = 180;
      }
    }, 1000)
  }
  Emailmodal() {
    this.EmailAddressmodal = true;
    this.profileReq.EmailID = this.profileObj.EmailID;
  }
  closemodal() {
    this.IsShowOTPBlock = false;
    this.ShowEmailTimer = false;
    clearInterval(this.interval);
    this.timeLeft = 180;
    this.isResendShowEmail = false;
    this.EmailAddressmodal = false;
  }
  ResendEmailOTP() {
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/ResendOTP_ForEmailUpdate", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/ResendOTP_ForEmailUpdate", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      if (this.st.StatusCode == "S") {
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.isResendShowEmail = false;
        this.showOTPTimerEmail();
        Swal(this.st.StatusDesc);
      } else {
        Swal(this.st.StatusDesc);
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }
  Passwordmodal() {
    this.PasswordUpdatemodal = true;
  }

  ClosePasswordmodal() {
    this.profileReq.Password = "";
    this.profileReq.NewPassword = "";
    this.profileReq.ConfirmPassword = "";
    this.PasswordUpdatemodal = false;
  }
  Addressmodal() {
    this.AddressUpdatemodal = true;
  }
  CloseAddressmodal() {
    this.AddressUpdatemodal = false;
  }


  Check() {
    if (this.profileReq.ConfirmPassword != this.profileReq.NewPassword) {
      this.PasswordMatched = false;
    }
    else {
      this.PasswordMatched = true;
    }
  }
  CheckPass() {
    this.profileReq.ConfirmPassword = '';
  }

  Langmodal() {
    this.LangUpdatemodal = true;
    if (this.profileObj.Language == "English" || this.profileObj.Language == "ENGLISH") {
      this.profileReq.Language = "en";
    }
    else {
      this.profileReq.Language = "ar";
    }
  }

  CloseLangmodal() {
    this.LangUpdatemodal = false;
  }


  Mobilemodal() {
    this.MobileUpdatemodal = true;
    this.profileReq.MobileNo = 0 + this.profileObj.MobileNo;
    this.RemainTime = 300;
    this.CurrentTime = 300;
    this.showOTP = false;
    this.isResendShow = false;
    this.isShowTimer = false;
  }

  closeMobilemodal() {
    this.MobileUpdatemodal = false;
    this.DisableMobileUpdate = true;
    this.subscription.unsubscribe();
    this.RemainTime = 0;
    this.CurrentTime = 0;
    this.showOTP = false;
    this.isResendShow = false;
    this.isShowTimer = false;
  }

  IBANmodal() {
    this.IBANUPDATEmodal = true;
    if ((this.profileObj.IBAN != null && this.profileObj.IBAN != '') && this.profileObj.IBAN.length == 24) {
      this.IBAN1 = this.profileObj.IBAN.substring(2, 4);
      this.IBAN2 = this.profileObj.IBAN.substring(4, 8);
      this.IBAN3 = this.profileObj.IBAN.substring(8, 12);
      this.IBAN4 = this.profileObj.IBAN.substring(12, 16);
      this.IBAN5 = this.profileObj.IBAN.substring(16, 20);
      this.IBAN6 = this.profileObj.IBAN.substring(20, 24);
    }
  }

  closeIBANmodal() {
    this.IBANUPDATEmodal = false;
  }
  getProfile() {

    this.isShowLoading = true;

    this.profileReq.RegNo = this.userinfo.EncriptString(sessionStorage.getItem("RegNo")).toString();


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<CustomerProfileMdl>(this.url.baseURL + "/PolicySettings/getProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.profileObj = result;

      // //New Line Start
      // this.objPayloadResponse = result;
      // this.profileObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      // //NewLine End


      //New Line Start
      this.objPayloadResponse = result;
      let objResObj: CustomerProfileMdl = new CustomerProfileMdl();
      objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

      if (objResObj.IqamaNo != sessionStorage.getItem("IqamaNo")) {
        Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
        this.router.navigate(['BeforeLogin/NewReg']);
        return;
      }

      this.profileObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      this.isShowLoading = false;
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }


  UpdatePwd(val) {
    if (!val) {
      Swal("Please Fill All Mandatory Fields..")
      return;
    }
    this.isShowLoading = true;
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.EditEmailAddress = false;
    this.profileReq.EditIBANNo = false;
    this.profileReq.EditMobileNo = false;
    this.profileReq.EditLang = false;
    this.profileReq.EditPassword = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      if (this.st.StatusCode == "S") {
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
        this.PasswordUpdatemodal = false;
        this.ClosePasswordmodal();
        this.getProfile();
      }
      else {
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }




  showOTPTimer() {
    this.isShowTimer = true;
    let seconds: number = 1000;
    this.CurrentTime = 300;
    this.RemainTime = 300;
    this.subscription = Observable.timer(0, seconds).takeUntil(Observable.timer(300000)).finally(() => {
      this.CurrentTime = 0;
      this.isShowTimer = false;
      this.isResendShow = true;
      this.ShowVerify = false;
    }).subscribe(t => {
      this.CurrentTime = this.RemainTime - t;
    });
  }


  verifyOTP() {
    this.otpReq.RegNo = Number(sessionStorage.getItem("RegNo"));
    this.showLoading = true;
    if (this.otpReq.OTP != null) {

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.otpReq));

      //this.http.post<OtpVerifyRes>(this.url.baseURL + "PolicySettings/VerifyOTP", this.otpReq, this.userinfo.getHttpOptions()).toPromise().then(result => {
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "PolicySettings/VerifyOTP", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then(result => {
        this.isShowLoading = false;
        //this.otpRes = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.otpRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End




        this.Lng == "en" ? Swal(this.otpRes.st.StatusDesc) : Swal(this.otpRes.st.StatusDescAr);
        if (this.otpRes.st.StatusCode === "S") {

          this.MobileUpdatemodal = false;
          this.isShowTimer = false;
          this.RemainTime = 300;
          this.otpReq.OTP = "";
          this.DisableMobileUpdate = true;
          this.subscription.unsubscribe();
          this.getProfile();
        }
        else {
          if (this.otpRes.st.Result === "E") {
            this.isShowLoading = false;
            this.subscription.unsubscribe();
            this.isShowTimer = true;
            this.isResendShow = true;
            this.showOTPTimer();
          }
        }
      }, (error) => {
        this.userinfo.checkTokenStatus(error);
        this.showLoading = false;
        this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      });
    }
  }





  UpdateMobile(Valid) {
    if(this.MobileNoVerified==false ){
      return;
    }
    if (Valid == false) {
      this.Lng == "en" ? Swal("Please Re-Check The Details And Submit") : Swal("Please Re-Check The Details And Submit");
      return;
    }

    this.isShowLoading = true;
    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.profileReq.EditEmailAddress = false;
    this.profileReq.EditIBANNo = false;
    this.profileReq.EditMobileNo = true;
    this.profileReq.EditLang = false;
    this.profileReq.EditPassword = false;



    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End



      if (this.st.StatusCode == "S") {
        this.isShowLoading = false;
        this.DisableMobileUpdate = false;
        this.ShowVerify = true;
        this.showOTP = true;
        this.showOTPTimer();
        this.getProfile();
      }
      else {
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
      }

    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }


  UpdateLang() {
    this.isShowLoading = true;
    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.profileReq.EditEmailAddress = false;
    this.profileReq.EditIBANNo = false;
    this.profileReq.EditMobileNo = false;
    this.profileReq.EditMobileNo = false;
    this.profileReq.EditLang = true;
    this.profileReq.EditPassword = false;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
      if (this.st.StatusCode == "S") {
        this.isShowLoading = false;
        this.LangUpdatemodal = false;
        sessionStorage.setItem("Lng", this.profileReq.Language);
        this.getProfile();
      }
      else {
        this.isShowLoading = false;
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });

  }


  iban1Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }


  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
      }
    }
  }


  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }

  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }

  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }

  UpdateIBAN() {
    if (!this.profileObj.AccountName || this.profileObj.AccountName.length === 0) {
      Swal("Please Enter Bank Account Holder name");
      return;
    }

    this.IBAN = "SA" + this.IBAN1 + this.IBAN2 + this.IBAN3 + this.IBAN4 + this.IBAN5 + this.IBAN6;
    this.profileReq.IBAN = this.IBAN;
    if (this.IBAN1 == null || this.IBAN2 == null || this.IBAN3 == null || this.IBAN4 == null || this.IBAN5 == null || this.IBAN6 == null || this.IBAN.length != 24) {
      this.Lng == "en" ? Swal("IBAN Number must be 24 digits") : Swal("يجب أن يكون رقم الايبان من 24 رقماً");
    }
    else {
      this.isShowLoading = true;
      this.profileReq.RegNo = sessionStorage.getItem("RegNo");
      this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
      this.profileReq.EditEmailAddress = false;
      this.profileReq.EditIBANNo = true;
      this.profileReq.EditMobileNo = false;
      this.profileReq.EditLang = false;
      this.profileReq.AccountName = this.profileObj.AccountName;
      this.profileReq.EditPassword = false;

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

      //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateProfile", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        //this.st = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End


        if (this.st.StatusCode == "S") {
          this.isShowLoading = false;
          Swal(this.st.StatusDesc);
          this.IBANUPDATEmodal = false;
          this.getProfile();
        }
        else {
          this.isShowLoading = false;
          this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
        }
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
        this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");

      });
    }
  }

  ResendOTP() {

    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.profileReq.EditEmailAddress = false;
    this.profileReq.EditIBANNo = false;
    this.profileReq.EditMobileNo = true;
    this.subscription.unsubscribe();
    this.RemainTime = 0;
    this.CurrentTime = 0;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/ResendOTP", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/ResendOTP", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      if (this.st.StatusCode == "S") {
        this.isShowLoading = false;
        this.ShowVerify = true;
        this.DisableMobileUpdate = false;
        this.isResendShow = false;
        this.showOTP = true;
        this.showOTPTimer();
      }
      else {
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.st.StatusDesc) : Swal(this.st.StatusDescAr);
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }


  UpdateAddress() {
    this.profileReq.RegNo = sessionStorage.getItem("RegNo");
    this.profileReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.profileReq));
    this.isShowLoading = true;
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/PolicySettings/ResendOTP", this.profileReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateAddress", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;
      this.isShowLoading = false;
      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      Swal(this.translate.instant(this.st.StatusDesc));
      if (this.st.StatusCode == "S") {
        this.getProfile();
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      this.isShowLoading = false;
    });
  }

  YakeenMobileNoVerify() {
  
    var req={
      Insured_IdNo:this.profileObj.IqamaNo,
      MobileNo:this.profileReq.MobileNo,
      USerId:this.profileReq.RegNo
      }
  
    this.showLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(req));
  
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Limra/YakeenMobileNoVerify", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((res) => {
      //this.st = res;
  
      //New Line Start
      this.objPayloadResponse  = res;
      this.YakeenMobileres = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End
     if(this.YakeenMobileres.StatusCode=="S")
     {
      if (this.YakeenMobileres.isOwner == false) {
        this.profileReq.MobileNo = "";
        this.MobileNoVerified =false;
        this.Lng == "ar" ? Swal("Please enter the Mobile Number registered in Absher") : Swal("Please enter the Mobile Number registered in Absher");
        
      }
     }
     else{
        Swal(this.YakeenMobileres.StatusDesc)
     }

      
      if(this.YakeenMobileres.isOwner == true){
        this.MobileNoVerified =true
      }
      this.showLoading = false;
    }, (res) => {
      Swal("Try agian");
      this.showLoading = false;
  
    });
  }
  
  allowEnglishOnly(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode);
    const pattern = /^[A-Za-z ]+$/;
    if (!pattern.test(char)) {
      Swal("Please Enter English Name only");
      event.preventDefault();
    }
  }
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Profile/Profile.ts